var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avue-top" },
    [
      _c("div", { staticClass: "top-bar__left" }, [
        _vm.showCollapse
          ? _c(
              "div",
              {
                staticClass: "avue-breadcrumb",
                class: [{ "avue-breadcrumb--active": _vm.isCollapse }],
              },
              [
                _c("i", {
                  staticClass: "icon-navicon",
                  on: { click: _vm.setCollapse },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "top-bar__title" }, [
        _c(
          "div",
          {
            staticClass: "top-menu",
            staticStyle: { display: "inline-block", "vertical-align": "top" },
          },
          [
            _c(
              "el-button",
              {
                staticClass: "el-menu-item",
                staticStyle: {
                  border: "none",
                  height: "64px",
                  background: "inherit",
                },
                attrs: { icon: "icon-shandian", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.onShowWx(0)
                  },
                },
              },
              [_vm._v("\n\t\t\t\t\t快速理赔\n\t\t\t\t")]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "top-menu",
            staticStyle: { display: "inline-block", "vertical-align": "top" },
          },
          [
            _c(
              "el-button",
              {
                staticClass: "el-menu-item",
                staticStyle: {
                  border: "none",
                  height: "64px",
                  background: "inherit",
                },
                attrs: { icon: "el-icon-eleme", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.onShowWx(1)
                  },
                },
              },
              [_vm._v("\n\t\t\t\t\t手机投保\n\t\t\t\t")]
            ),
          ],
          1
        ),
        _vm.showMenu
          ? _c(
              "div",
              { staticClass: "top-bar__item top-bar__item--show" },
              [_c("top-menu")],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "top-bar__right" },
        [
          _vm.showDebug
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.logsFlag
                      ? "没有错误日志"
                      : _vm.logsLen + "条错误日志",
                    effect: "dark",
                    placement: "bottom",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "top-bar__item" },
                    [_c("top-logs")],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.showLock
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "锁屏",
                    effect: "dark",
                    placement: "bottom",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "top-bar__item" },
                    [_c("top-lock")],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.showTheme
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "特色主题",
                    effect: "dark",
                    placement: "bottom",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "top-bar__item top-bar__item--show" },
                    [_c("top-theme")],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.showFullScreen
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.isFullScreen ? "退出全屏" : "全屏",
                    effect: "dark",
                    placement: "bottom",
                  },
                },
                [
                  _c("div", { staticClass: "top-bar__item" }, [
                    _c("i", {
                      class: _vm.isFullScreen
                        ? "icon-zuixiaohua"
                        : "icon-quanpingzuidahua",
                      on: { click: _vm.handleScreen },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.userInfo.avatar
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "用户头像",
                    effect: "dark",
                    placement: "bottom",
                  },
                },
                [
                  _c("img", {
                    staticClass: "top-bar__img",
                    attrs: { id: "thumbnail", alt: "", src: "" },
                  }),
                ]
              )
            : _vm._e(),
          _c(
            "el-dropdown",
            { staticStyle: { "margin-left": "10px" } },
            [
              _c("div", { staticClass: "u-flex u-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "u-flex-col u-col-center",
                    staticStyle: { "margin-right": "5px" },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.userInfo ? _vm.userInfo.username : "未知") +
                        "\n\t\t\t\t\t\t"
                    ),
                    _vm.envConfig.isBxXsm() &&
                    _vm.userInfo &&
                    _vm.userInfo.distAccount
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "text-align": "center",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t工号：" +
                                _vm._s(_vm.userInfo.distAccount.number) +
                                "\n\t\t\t\t\t\t"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _c("i", {
                  staticClass: "el-icon-arrow-down el-icon&#45;&#45;right",
                }),
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    { attrs: { divided: "" } },
                    [
                      _c("router-link", { attrs: { to: "/" } }, [
                        _vm._v("首页"),
                      ]),
                    ],
                    1
                  ),
                  _vm.userInfo &&
                  _vm.userInfo.userType != "sys" &&
                  _vm.showYearEnd
                    ? _c("el-dropdown-item", { attrs: { divided: "" } }, [
                        _c("div", { on: { click: _vm.openMyNz } }, [
                          _vm._v("我的 2024"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.permissions["createChannelByCode"]
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.generatedCode.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t\t生成邀请码\n\t\t\t\t\t")]
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("退出系统")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("top-setting", { ref: "seting" }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "font-weight": "500" } },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.getWxData.title,
                visible: _vm.dialogVisible,
                width: "30%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.getWxData.content))]),
              _c("div", { staticStyle: { "margin-top": "50px" } }, [
                _c("img", {
                  staticStyle: {
                    height: "230px",
                    padding: "10px",
                    border: "1px solid #ddd",
                  },
                  attrs: { src: _vm.getWxData.imgUrl, alt: "" },
                }),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.generatedCodeFlag,
            "append-to-body": "",
            title: "注册二维码",
          },
          on: {
            "update:visible": function ($event) {
              _vm.generatedCodeFlag = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                display: "flex",
                "justify-content": "center",
              },
            },
            [
              _c("img", {
                staticStyle: { width: "200px", height: "200px" },
                attrs: { src: _vm.codeUrl, alt: "" },
              }),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "year-report-dialog",
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.isShowNzzj,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowNzzj = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "year_report_main" },
            [
              _c(
                "div",
                {
                  staticClass: "close-icon",
                  staticStyle: {
                    position: "absolute",
                    top: "12px",
                    right: "-42px",
                    "z-index": "99",
                    "font-size": "28px",
                    color: "#fff",
                    cursor: "pointer",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-close",
                    on: { click: _vm.closeNzzj },
                  }),
                ]
              ),
              _c("newYearReportModal"),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }